import { isAceleresIndividualOwn } from 'dashboard/constants/aceleresConnectionTypes';

export const viewerOwnsPersonalInboxUnreadState = ({
  currentUserId,
  personalInboxAttributes = {},
  personalConversationOwnerId,
}) => {
  const normalizedCurrentUserId = Number(currentUserId);
  const personalInboxOwnerId = Number(
    personalInboxAttributes?.owner_chatwoot_user_id ||
      personalInboxAttributes?.ownerChatwootUserId ||
      0
  );
  const conversationOwnerId = Number(personalConversationOwnerId || 0);

  return (
    (isAceleresIndividualOwn(personalInboxAttributes?.connection_type) &&
      personalInboxOwnerId === normalizedCurrentUserId) ||
    (conversationOwnerId > 0 && conversationOwnerId === normalizedCurrentUserId)
  );
};

// Toda conversa em Novos mostra a bolinha de não-lido pra quem está vendo a
// lista: sem dono (fila compartilhada) mostra pra qualquer agente; com dono
// — mesmo recém-atribuída/transferida e ainda não "iniciada" — mostra pro
// responsável. A bolinha some quando alguém abre a conversa e volta a
// acender numa próxima transferência.
export const viewerOwnsUnreadState = ({
  currentUserId,
  assigneeId,
  preserveAssignedUnread = false,
  personalInboxAttributes = {},
  personalConversationOwnerId,
}) => {
  return (
    preserveAssignedUnread ||
    !assigneeId ||
    Number(assigneeId) === Number(currentUserId) ||
    viewerOwnsPersonalInboxUnreadState({
      currentUserId,
      personalInboxAttributes,
      personalConversationOwnerId,
    })
  );
};

// Novos/Outros/Pessoais são caixas compartilhadas: quem está navegando ali
// não é necessariamente o assignee da conversa, mas precisa ver o que está
// novo na fila mesmo assim. Só "Meus" restringe o não-lido a quem é dono.
export const shouldPreserveAssignedUnreadForBox = box =>
  ['novos', 'outros', 'pessoais'].includes(String(box || ''));

export const sanitizeConversationUnreadForViewer = (
  conversation,
  currentUserId,
  { preserveAssignedUnread = false } = {}
) => {
  if (!conversation) {
    return conversation;
  }

  const assigneeId =
    conversation?.meta?.assignee?.id ??
    conversation?.assignee_id ??
    conversation?.conversation?.assignee_id;

  if (
    viewerOwnsUnreadState({
      currentUserId,
      assigneeId,
      preserveAssignedUnread,
    })
  ) {
    return conversation;
  }

  return {
    ...conversation,
    unread_count: 0,
  };
};

export const sanitizeConversationListUnreadForViewer = (
  conversations,
  currentUserId,
  options = {}
) => {
  if (!Array.isArray(conversations)) {
    return [];
  }

  return conversations.map(conversation =>
    sanitizeConversationUnreadForViewer(conversation, currentUserId, options)
  );
};

export const sanitizeMessageConversationUnreadForViewer = (
  message,
  currentUserId,
  options = {}
) => {
  if (!message?.conversation) {
    return message;
  }

  return {
    ...message,
    conversation: sanitizeConversationUnreadForViewer(
      message.conversation,
      currentUserId,
      options
    ),
  };
};
